import { useAnalytics } from "@codat/analytics";
import { TextInput as OrchardTextInput } from "@codat/orchard-ui";
import { TextInputProps as OrchardTextInputProps } from "@codat/orchard-ui/dist/es/components/TextInput";
import debounce from "lodash.debounce";
import { useCallback } from "react";

interface TextInputProps extends Omit<OrchardTextInputProps, "ref"> {
  analyticsName: string;
}

const DEBOUNCE_MS = 1000;

export const TextInput: React.FC<TextInputProps> = (props) => {
  const { analyticsName, onChange, ...textInputProps } = props;
  const analytics = useAnalytics();

  const track = useCallback(debounce(analytics.sendEvent, DEBOUNCE_MS), []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value) {
      track(`${analyticsName} text input - Typed`, {
        searchText: e.target.value,
      });
    }
    if (onChange) {
      onChange(e);
    }
  };

  return <OrchardTextInput onChange={handleOnChange} {...textInputProps} />;
};
